module.exports = __webpack_public_path__ + "img/logo-lanqimu-white.597bc206.png";